module.exports = __webpack_public_path__ + "static/media/logo.bc86d695.png";